<template>
    <!-- 工厂小组配置 -->
    <el-row style="text-align: left">
        <el-dialog
                @closed="createDialogClosed"
                :visible.sync="show"
                width="30%"
                :append-to-body="true"
                title="创建小组">

            <el-form ref="createGroupForm" :rules="rules" label-width="100px" :model="createNewGroupFormData">
                <el-form-item :rules="rules.requiredRules" prop="name" label="名称:" size="mini">
                    <el-input v-model="createNewGroupFormData.name"></el-input>
                </el-form-item>

                <el-form-item :rules="rules.requiredRules" prop="factory" label="所属工厂:" size="mini">
                    <el-select v-model="createNewGroupFormData.factory">
                        <el-option
                                :disabled="!factory.is_using"
                                :value="factory.id"
                                :label="factory.name"
                                :key="factory.id"
                                v-for="factory in produceFactories">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item size="mini" label="小组人数">
                    <el-input-number v-model="createNewGroupFormData.workers" :min="1"></el-input-number>
                </el-form-item>

                <el-form-item :rules="rules.requiredRules" size="mini" prop="tel"  label="联系方式">
                    <el-input v-model="createNewGroupFormData.tel"></el-input>
                </el-form-item>

                <el-form-item size="mini" label="是否停用">
                    <el-select v-model="createNewGroupFormData.is_using">
                        <el-option :value="false" label="停用"></el-option>
                        <el-option :value="true" label="不停用"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-row style="margin: 10px 0">
                <el-button @click="createNewGroup" :loading="createLoading" size="mini" type="primary">完成</el-button>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="show = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-table :data="produceGroups">
            <el-table-column prop="name" label="名称"/>
            <el-table-column prop="factory_name" label="所属工厂"/>
            <el-table-column prop="tel" label="联系方式"/>
            <el-table-column label="停用">
                <template slot-scope="{ row }">
                    <el-tag size="mini" type="danger" v-if="!row.is_using">
                        停用
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="workers" label="小组人数"/>
        </el-table>

        <el-row style="margin: 10px 0">
            <el-button @click="show=true" type="primary" size="mini">添加小组</el-button>
        </el-row>
    </el-row>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'

    export default {
        name: "FactoryGroupSetup",
        data() {
            return {
                // createNewGroup 打开/关闭标志
                show: false,

                url: '/order_platform/api/produce_groups/',

                // createNewGroup 点击加载过程
                createLoading: false,

                // createNewGroup 表单验证数据
                createNewGroupFormData: {
                    name: '',
                    factory: '',
                    is_using: true,
                    workers: 1,
                    tel:'',
                },

                // createNewGroup 表单验证规则
                rules: {
                    requiredRules: [
                        {required: true, message: '必填项', trigger: 'blur'}
                    ],
                },
            }
        },
        computed: {
            ...mapState(['produceGroups', 'produceFactories'])
        },
        methods: {
            /**
             * 点击创建信息小组
             */
            createNewGroup() {
                this.$refs.createGroupForm.validate(validated => {
                    if (validated) {
                        this._sendCreateNewGroup()
                    }
                })
            },

            /**
             * 发送创建新小组请求
             */
            _sendCreateNewGroup() {
                this.createLoading = true
                this.$postRequest(this.url, this.createNewGroupFormData)
                    .then(response => {
                        this.createLoading = false
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '创建小组成功'
                        })
                        const newGroups = this.produceGroups.concat([response.data])
                        this.setProduceGroups(newGroups)
                        this.show = false
                    })
                    .catch(() => {
                        this.createLoading = false
                    })
            },

            /**
             * 关闭创建小组对话框
             */
            createDialogClosed() {
                this.createNewGroupFormData.name = ''
                this.createNewGroupFormData.factory = ''
                this.createNewGroupFormData.is_using = true
                this.createNewGroupFormData.workers = 1
                this.createNewGroupFormData.tel = ''
            },

            ...mapMutations(['setProduceGroups'])
        },
    }
</script>

<style scoped>

</style>